var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1388_2523)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47644 19C3.25644 19 3.06144 18.855 2.99744 18.645C2.93444 18.434 3.01644 18.206 3.19944 18.084C5.21544 16.74 5.70344 15.477 5.82144 14.928C2.82344 13.577 0.97644 11.142 0.97644 8.5C0.97644 4.364 5.46244 1 10.9764 1C16.4904 1 20.9764 4.364 20.9764 8.5C20.9764 12.636 16.4904 16 10.9764 16C10.8714 16 10.7674 15.996 10.6634 15.991C7.56244 18.966 3.64444 19 3.47644 19ZM6.85844 14.677C6.84944 15.023 6.70544 16.296 5.19344 17.768C6.55144 17.464 8.47944 16.766 10.0834 15.162L10.0844 15.161C10.1834 15.042 10.3414 14.985 10.4854 14.981L10.6694 14.99C10.7714 14.995 10.8724 15 10.9764 15C15.9384 15 19.9764 12.084 19.9764 8.5C19.9764 4.916 15.9384 2 10.9764 2C6.01444 2 1.97644 4.916 1.97644 8.5C1.97644 10.829 3.72944 12.995 6.55244 14.153C6.76144 14.239 6.88544 14.454 6.85844 14.677Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1388_2523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    fill: "white",
    transform: "translate(0.97644 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.16fd06b5b8dbdd1a301ceee14ed06569.svg";
export { ForwardRef as ReactComponent };